import decryptAES256GCM from '@utils/decryptAES';
import { date, showAlert } from '../../lib/helpers';
import {detailHeaders, searchDetail, filterData } from './attributes';

export default {
  data: () => ({
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    detailHeaders,
    search: searchDetail,
    filterData,
    clientID: null,
    merchantData: {
      aggregator_name: '',
      merchant_name: '',
      mid: '',
      email: '',
      client_type: '',
      callback_partner_id: '',
      callback_partner_secret: '',
      callback_partner_url_token: '',
      inbound_merchant_public_key: '',
      callback_url: ''
    },
    isInitialLoad: true,
    showCopyTooltip: false,
    copyTooltipText: 'Copy Public Key',
  }),

  mounted() {
    window.scrollTo(0, 0);
  },

  computed: {
    decryptedPublicKey(){
      return this.merchantData?.inbound_merchant_public_key 
        ? decryptAES256GCM(this.merchantData.inbound_merchant_public_key)
        : '';
    },
    allData() {
      return this.$store.state.merchantCallbackManagement.allData;
    },
    totalData() {
      return this.$store.state.merchantCallbackManagement.totalData;
    },
    totalPage() {
      return this.$store.state.merchantCallbackManagement.totalPage;
    },
    loading() {
      return this.$store.state.merchantCallbackManagement.loading;
    },
    isSubMerchant() {
      return this.merchantData.aggregator_name && this.merchantData.aggregator_name !== '';
    }
  },
  
  watch: {
    options: {
      handler() {
        if (this.clientID && !this.isInitialLoad) {
          this.getData();
        }
        this.isInitialLoad = false;
      },
      deep: true,
      immediate: false 
    },
  },

  
  async created() {
    const {id} = this.$route.params;
    if (id) {
      this.clientID = id;
      await Promise.all([
        this.fetchMerchantDetail(id),
        this.getData()
      ]);
    }
  },

  methods: {   
    goBack() {
      this.$router.push('/management-merchant-api');
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.copyTooltipText = 'Copied!';
        this.showCopyTooltip = true;
        setTimeout(() => {
          this.showCopyTooltip = false;
          this.copyTooltipText = 'Copy Key';
        }, 2000);
      } catch (err) {
        this.copyTooltipText = 'Failed to copy';
        this.showCopyTooltip = true;
        setTimeout(() => {
          this.showCopyTooltip = false;
          this.copyTooltipText = 'Copy Key';
        }, 2000);
      }
    },
    async fetchMerchantDetail(id) {
      try {
        const response = await this.$store.dispatch('merchantCallbackManagement/getDetail', { 
          id,
          date
        });
        
        if (response) {
          this.merchantData = {
            ...this.merchantData,
            ...response
          };
        }
      } catch (error) {
        showAlert(this.$store, 'Error fetching merchant details', 'mdi-alert', 'red');
      }
    },
    getData() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('merchantCallbackManagement/getTableDetail', {
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          clientID: this.clientID,
          search: this.search,
          date
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
      
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.nmid = '';
      this.search.mobile_phone = '';
      this.search.qr_type = '';
    },

  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};